/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCampaignDto } from '../../models/discount-campaign-dto';
import { DiscountCampaignShowResponse } from '../../models/discount-campaign-show-response';

export interface PostDiscountCreate$Params {
      body: DiscountCampaignDto
}

export function postDiscountCreate(http: HttpClient, rootUrl: string, params: PostDiscountCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCampaignShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postDiscountCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCampaignShowResponse>;
    })
  );
}

postDiscountCreate.PATH = '/v1/discount';
